export enum PanelName {
	CommentsPanel = 'commentsPanel',
	DetailsPanel = 'detailsPanel',
	WorkflowsPanel = 'workflowsPanel',
	AIAudioPanel = 'aiAudioPanel',
	LoomScriptPanel = 'loomScriptPanel',
}
